<template>
  <div class="my">
    <m-header></m-header>

    <!-- 广告 -->
    <div class="user-ad" v-if="bannerList.length">
      <swiper class="banner-swiper" :options="swiperBanner">
        <swiper-slide v-for="inner in bannerList" :key="inner.bannerId" class="banner-swiper-item">
          <div class="banner-swiper-item-box" @click="goBanner(inner)">
            <img class="banner-img" :src="linkAllImgUrl(inner.imageUrl)">
          </div>
        </swiper-slide>
        <div class="banner-pagination" slot="pagination"></div>
      </swiper>
    </div>

    <div class="user-box">
      <div class="user-body">
        <!-- 导航 -->
        <div class="user-body-left">
          <m-nav />
        </div>
        <!-- 页面 -->
        <div class="user-body-right">

          <router-view />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBannerApi } from "@/api/user";
import commonMixin from "@/mixins/commonMixin";
import mNav from "@/components/users/nav.vue";
export default {
  mixins: [commonMixin],
  data () {
    return {
      /* banner swiper */
      bannerList: [],
      swiperBanner: {
        autoplay: true,
        pagination: {
          el: '.banner-pagination'
        }
      },

    }
  },
  created () {
    this.getBanner();

  },

  methods: {
    getBanner () {
      /* 1 首页 2 搜索页 3 活动页  4广告*/
      getBannerApi({ position: 4 }).then(res => {
        if (res.code == 200) {
          this.bannerList = res.data;
        }
      });
    },
    goBanner (item) {
      if (item.type == 2) {
        window.location.href = item.jumpUrl;
      }
    }
  },
  components: {
    mNav
  }
};
</script>

<style lang="less">
.my {
  min-width: 1200px;
}

.user-box {
  // padding-top: 20px;
  padding-bottom: 50px;
  width: 1230px;
  margin: 0 auto;
}

.user-ad {
  // margin-top: 20px;
  width: 100%;
  min-width: 1200px;

  // height: 120px;
  .banner-swiper {
    width: 100%;

    // height: 120px;
    .banner-swiper-item {
      width: 100%;

      // height: 120px;
      .banner-swiper-item-box {
        width: 100%;

        // height: 120px;
        .banner-img {
          width: 100%;
          // height: 120px;
          background-size: cover;
          background-position: center;
        }
      }
    }

    .banner-pagination {
      position: absolute;
      z-index: 9;
      text-align: center;
    }
  }
}

.user-body {
  display: flex;
  margin-top: 30px;
  justify-content: space-between;

  .user-body-left {
    overflow: hidden;
    width: 220px;
    border-radius: 5px;
  }

  .user-body-right {
    height: 85vh;
    overflow: auto;
    margin-left: 20px;
    flex: 1;
    border-radius: 5px;
    background-color: #ffffff;
  }
}
</style>
